import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {

  /**
   * Order an array by key
   * @param {any[]} array
   * @param {string} key
   * @param {string} order
   * @returns {any}
   */
  transform(array: any[], key: string, order?: string, key2?: string): any {
    array = array.sort((a, b) => {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      if (key2 !== null) {
        if (a[key2] < b[key2]) {
          return -1;
        } else if (a[key2] > b[key2]) {
          return 1
        }
      }
      return 0;
    });
    if (order === 'desc') {
      return array.reverse();
    }
    return array;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/order-by.pipe.ts